/**
 * FilterChip — reusable toggle chip for the interactive legend filter.
 *
 * Active: filled with color, light text.
 * Inactive: outlined, muted text, 20% opacity.
 */

interface FilterChipProps {
  label: string;
  color: string;
  isActive: boolean;
  onToggle: () => void;
}

export function FilterChip({ label, color, isActive, onToggle }: FilterChipProps) {
  return (
    <button
      onClick={onToggle}
      className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium transition-all whitespace-nowrap"
      style={{
        background: isActive ? color + '33' : 'transparent',
        border: `1px solid ${isActive ? color + '66' : 'var(--glass-border)'}`,
        color: isActive ? 'var(--text-primary)' : 'var(--text-dim)',
        opacity: isActive ? 1 : 0.5,
        cursor: 'pointer',
      }}
    >
      <span
        className="w-2 h-2 rounded-full shrink-0"
        style={{ backgroundColor: color, opacity: isActive ? 1 : 0.3 }}
      />
      {label}
    </button>
  );
}
